import {AgentPairingType} from "../../agents/types/agentPairing.type";
import {AgentValidationType} from "../../agents/types/agentValidation.type";
import {ServiceType} from "../../deliveries/types/service.type";
import {QuoteType} from "../../fulfillment/types/quote.type";
import {CreateServiceLocationSourceType} from "../types/create-service-location-source.type";

export enum AgentValidationAndPairingModeType {
  Delivery = "Delivery",
  Operation = "Operation",
  All = "All"
}

export interface AgentFeatureModel {
  enabled: boolean;
}

export interface AgentModulesModel {
  market: AgentFeatureModel;
  billing: AgentFeatureModel;
  auctions: AgentFeatureModel;
  displaySchedule: AgentFeatureModel;
  missingItem: AgentFeatureModel;
  loadingOrder: AgentFeatureModel;
  itineraryInfo: AgentFeatureModel;
  allowCancel: AgentFeatureModel;
  allowContactNotAvailable: AgentFeatureModel;
  disableContactNotAvailableLock: AgentFeatureModel;
  countMileage: AgentFeatureModel;
  displayAdditionalInfo: AgentFeatureModel;
  createOrder: AgentFeatureModel;
  onDutyBasedOnServiceArea: AgentFeatureModel;
  onDutyBasedOnShift: AgentFeatureModel;
  geofencingEnabled: AgentFeatureModel;
  allowAddAdditions: AgentFeatureModel;
  allowAddExpense: AgentFeatureModel;
  blockDepartedBeforeTimeWindow: AgentFeatureModel;
  offline: AgentFeatureModel;
  chat: AgentFeatureModel;
  allowRevert: AgentFeatureModel;
  disableChangeLogisticVehicle: AgentFeatureModel;
  agentInventory: AgentFeatureModel;
  selfAssign: AgentFeatureModel;
  timekeepingPortal: AgentFeatureModel;
  timekeepingApp: AgentFeatureModel;
  branchSummaryPortal: AgentFeatureModel;
  branchSummaryApp: AgentFeatureModel;
}

export interface GeofencingPreferencesModel {
  geofencingBlockArrivalOutOfRange: boolean;
  geofencingBlockDepartureOutOfRange: boolean;
  geofencingBlockAbortOutOfRange: boolean;
  geofencingArrivalTaskRadius: number;
  geofencingDepartureTaskRadius: number;
  geofencingDepartureBufferMinutes: number;
  geofencingAbortTaskRadius: number;
  geofencingPickupEnabled: boolean;
  geofencingDropoffEnabled: boolean;
  geofencingInternalEnabled: boolean;
  geofencingOperationEnabled: boolean;
  distanceValidationRadius: number;
  geofencingAutoArrivals: boolean;
  geofencingDistanceValidationTimerSeconds: number;
  geofencingMaxLastKnownLocationTimestampGapMinutes: number;
}

export interface PairingPreferencesModel {
  validationAndPairingMode: AgentValidationAndPairingModeType;
  pairingOption: AgentPairingType;
  validationOption: AgentValidationType;
  forceValidation: boolean;
  forcePairing: boolean;
  quickValidation: boolean;
  clickToScan: boolean;
  quantityValidation: boolean;
}

export interface BreakPreferencesModel {
  autoBackFromBreak: boolean;
  breakDurationMinutes: number;
  backFromBreakReminderGapMinutes: number;
}

export interface RouteCostPreferencesModel {
  considerMinimumRouteCostValue: boolean;
  minimumRouteCostValue: number;
  considerMaximumRouteCostValue: boolean;
  maximumRouteCostValue: number;
}

export interface RouteSelfAssignPreferencesModel {
  allowRouteSelfAssign: boolean;
  allowOverwritingRouteSelfAssignment: boolean;
  allowOverwritingStartedRouteSelfAssignment: boolean;
  allowSelfUnassignFromRoute: boolean;
  allowSelfUnassignFromStartedRoute: boolean;
  allowAutoReassignToDefaultAgent: boolean;
}

export interface ServiceSelfAssignPreferencesModel {
  allowServiceSelfAssign: boolean;
  allowOverwritingServiceSelfAssignment: boolean;
  allowOverwritingStartedServiceSelfAssignment: boolean;
  allowOverwritingOnlyMatchingBranchesOfServiceSelfAssignment: boolean;
  allowSelfUnassignService: boolean;
  allowSelfUnassignStartedService: boolean;
}

export interface CreateServicePreferencesModel {
  serviceTypes: ServiceType[];
  quoteTypes: QuoteType[];
  pickupLocationSources: CreateServiceLocationSourceType[];
  dropoffLocationSources: CreateServiceLocationSourceType[];
}

export interface StationaryNotificationPreferencesModel {
  enabled: boolean;
  coordinateRecordingIntervalMinutes: number;
  evaluationIntervalMinutes: number;
  stationaryRadiusMeters: number;
  maximumNotificationsNumberPerHour: number;
  createServiceNotification: boolean;
  createServiceInAppNotification: boolean;
}

export interface NotificationsPreferencesModel {
  stationaryNotificationPreferences: StationaryNotificationPreferencesModel;
}

export interface ValidationsPreferencesModel {
  ignoreValidations: boolean;
  ignoreValidationOption: AgentValidationType;
  blockValidationForUnpackedTasks: boolean;
  clickToScan: boolean;
}

export interface AgentSupportInfoModel {
  displaySupport: boolean;
  phone: string;
  url: string;
  urlName: string;
}

export interface AgentAppPreferencesModel {

    modules: AgentModulesModel;
    maxNumberOfServices: number;
    blockWhileClockedOutActions: string[];
    completeAndHeadingOption: boolean;
    ignoreForceUpdate: boolean;
    forceGps: boolean;
    displayWarningMessages: boolean;
    disableDistanceValidationWhenAddressQualityLow: boolean;
    forceDropOffsOfStartedServicesBeforePickups: boolean;
    displayRunners: boolean;
    allowDownloadAttachment: boolean;
    geofencingPreferences: GeofencingPreferencesModel;
    pairingPreferences: PairingPreferencesModel;
    breakPreferences: BreakPreferencesModel;
    routeCostPreferences: RouteCostPreferencesModel;
    routeSelfAssignPreferences: RouteSelfAssignPreferencesModel;
    serviceSelfAssignPreferences: ServiceSelfAssignPreferencesModel;
    createServicePreferences: CreateServicePreferencesModel;
    notificationsPreferences: NotificationsPreferencesModel;
    validationsPreferences: ValidationsPreferencesModel;
    agentSupportInfo: AgentSupportInfoModel;
}
